module.exports = __webpack_public_path__ + "img/table32_01.00e173f6.png";